import { getConfig } from '../utils/sessionStorageUtils';
import { IUser } from '../interfaces/auth';
import axios from './axios';

export const login = async (user: IUser) => {
  try {
    const result = await axios.post(`/auth/login`, user);
    sessionStorage.setItem('accessToken', result?.data?.data?.accessToken.token);
    sessionStorage.setItem('refreshToken', result?.data?.data?.refreshToken.token);
    return result?.data?.data?.accessToken;
  } catch (e) {
    alert('Invalid credentials!');
  }
};

export const refreshToken = async (accessToken: string, refreshToken: string) => {
  try {
    const result = await axios.post(`/Auth/refresh`, { accessToken, refreshToken });
    sessionStorage.setItem('accessToken', result?.data?.data?.accessToken.token);
    sessionStorage.setItem('refreshToken', result?.data?.data?.refreshToken.token);
    return result?.data?.data?.accessToken;
  } catch (e) {
    console.log(e);
  }
};

export const changePasswordApi = async (currentPassword: string, password: string, confirmPassword: string) => {
  try {
    const result = await axios.post(
      `/Auth/change-password`,
      { currentPassword, password, confirmPassword },
      getConfig()
    );
    return result?.data?.data;
  } catch (e) {
    console.log(e);
    return e;
  }
};
